<template>
  <div class="login-container">
    <div class="container">
      <div class="header">
        <img class="logo" src="../assets/sgcc-black.png" alt="BEAPAYDAY">
        <h2 class="title">Sign in to your account</h2>
      </div>

      <div class="form-container">
        <!-- STEP 1: LOGIN FORM -->
        <q-form v-if="!showOTP" class="form" ref="vForm" @submit="onSubmit">
          <div>
            <label for="email" class="label">Username or Email</label>
            <div class="input-container">
              <input id="email" name="email" type="text" autocomplete="email" required class="input-field"
                :disable="isSubmitted" v-model="login" lazy-rules :rules="[formRules.required]" />
            </div>
          </div>

          <div>
            <div class="password-label">
              <label for="password" class="label">Password</label>
            </div>
            <div class="input-container">
              <input id="password" name="password" type="password" autocomplete="current-password" required
                class="input-field" :disable="isSubmitted" v-model="password" lazy-rules
                :rules="[formRules.required]" />
            </div>

            <p class="error-text" style="text-align: center;" v-if="isInvalid">*Invalid Credentials</p>
          </div>

          <div class="submit-button-container">
            <q-btn rounded class="submit-button" label="Log in" :loading="isSubmitted" type="submit" />
          </div>
        </q-form>

        <!-- STEP 2: OTP VERIFICATION -->
        <q-form v-else class="form" @submit="verifyOTP">
          <div>
            <label for="otp" class="label">Enter Verification Code</label>
            <div class="input-container">
              <input id="otp" name="otp" type="text" maxlength="6" required class="input-field" v-model="otpCode" autocomplete="one-time-code"
                lazy-rules :rules="[formRules.required]" />
            </div>
            <p class="error-text" v-if="otpInvalid" style="text-align: center;">*Invalid OTP</p>
          </div>

          <div class="submit-button-container">
            <q-btn rounded class="submit-button" label="Verify OTP" :loading="isSubmitted" type="submit" />
          </div>

          <div class="resend-container" style="text-align:center; margin-top:10px;">
            <q-btn flat label="Resend Code" @click="resendOTP" />
          </div>
        </q-form>

        <p class="footer-text" v-if="!showOTP">
          Forgot Password?
          <a class="footer-link" @click="prompt = true" style="cursor: pointer">Change Password</a>
        </p>
      </div>

      <div class="q-pa-md q-gutter-sm play-store-box flex flex-center" style="margin-top: 20px;">
        <a href="#" @click="apple = true">
          <img src="../assets/appstore.png" alt="Download on the AppStore" height="40">
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.je310Solution.hrisbeapay" target="_blank">
          <img src="../assets/play_store.png" alt="Get on Google Play" height="40">
        </a>
      </div>

      <div class="contact-info">
        <p class="contact-address">
          3A PG Building, West Avenue,<br>
          Barangay Paltok, Quezon City, Philippines
        </p>

        <p class="contact-phone">
          <span class="phone-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.3308 15.9402L15.6608 14.6101C15.8655 14.403 16.1092 14.2384 16.3778 14.1262C16.6465 14.014 16.9347 13.9563 17.2258 13.9563C17.517 13.9563 17.8052 14.014 18.0739 14.1262C18.3425 14.2384 18.5862 14.403 18.7908 14.6101L20.3508 16.1702C20.5579 16.3748 20.7224 16.6183 20.8346 16.887C20.9468 17.1556 21.0046 17.444 21.0046 17.7351C21.0046 18.0263 20.9468 18.3146 20.8346 18.5833C20.7224 18.8519 20.5579 19.0954 20.3508 19.3L19.6408 20.02C19.1516 20.514 18.5189 20.841 17.8329 20.9541C17.1469 21.0672 16.4427 20.9609 15.8208 20.6501C10.4691 17.8952 6.11008 13.5396 3.35083 8.19019C3.03976 7.56761 2.93414 6.86242 3.04914 6.17603C3.16414 5.48963 3.49384 4.85731 3.99085 4.37012L4.70081 3.65015C5.11674 3.23673 5.67937 3.00464 6.26581 3.00464C6.85225 3.00464 7.41488 3.23673 7.83081 3.65015L9.40082 5.22021C9.81424 5.63615 10.0463 6.19871 10.0463 6.78516C10.0463 7.3716 9.81424 7.93416 9.40082 8.3501L8.0708 9.68018C8.95021 10.8697 9.91617 11.9926 10.9608 13.04C11.9994 14.0804 13.116 15.04 14.3008 15.9102L14.3308 15.9402Z"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          +63 908 875 1787
        </p>
      </div>
    </div>

    <q-dialog v-model="prompt" persistent>
      <q-card style="min-width: 350px">
        <q-card-section>
          <div class="text-h6">Enter your employee ID</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <q-input dense v-model="employeeid" autofocus label="Employee ID" />
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn flat label="Cancel" v-close-popup />
          <q-btn flat label="Submit" @click="forgotPassword" />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="apple" persistent>
      <q-card style="min-width: 350px">
        <q-card-section>
          <div class="text-h6">How to download iOS app</div>
        </q-card-section>
        <q-card-section class="q-pt-none">
          <q-list padding dense class="rounded-borders">
            <q-item clickable v-ripple>
              <q-item-section class="text-red">Request a redemption code for IT personnel.</q-item-section>
            </q-item>
            <q-item clickable v-ripple>
              <q-item-section>1. Open your App Store application.</q-item-section>
            </q-item>
            <q-item clickable v-ripple>
              <q-item-section>2. Click your Account.</q-item-section>
            </q-item>
            <q-item clickable v-ripple>
              <q-item-section>3. Click "Redeem Gift Card or Code".</q-item-section>
            </q-item>
            <q-item clickable v-ripple>
              <q-item-section>4. Click "Enter Code Manually".</q-item-section>
            </q-item>
            <q-item clickable v-ripple>
              <q-item-section>5. Enter CODE and click "Redeem" button.</q-item-section>
            </q-item>
          </q-list>
        </q-card-section>
        <q-card-actions align="right" class="text-primary">
          <q-btn flat label="Close" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import vueCookies from 'vue-cookies';
export default {
  name: "Login",
  data: () => ({
    login: null,
    password: null,
    otpCode: null,
    userId: null,
    showOTP: false,
    isSubmitted: false,
    isInvalid: false,
    otpInvalid: false,

    prompt: false,
    apple: false,
    employeeid: '',
    formRules: {
      required: val => !!val || 'Required'
    }
  }),
  methods: {
    // STEP 1: LOGIN
    onSubmit() {
      this.isSubmitted = true;
      this.isInvalid = false;
      const formData = new FormData();
      formData.append("login", this.login.trim());
      formData.append("password", this.password.trim());

      axios.post(this.apiUrl + "/login", formData)
        .then(res => {
          this.isSubmitted = false;
          if (res.data.status) {
            if (res.data.requires_2fa) {
              this.userId = res.data.user_id;
              this.showOTP = true; // show OTP input
            } else {
              // Direct login without 2FA
              vueCookies.set(this.cookieKey, {
                'user': res.data.data,
                'token': res.data.token
              });
              this.redirectUser(res.data);
            }
          } else {
            this.isInvalid = true;
          }
        })
        .catch(() => {
          this.isSubmitted = false;
          this.isInvalid = true;
        });
    },

    // STEP 2: VERIFY OTP
    verifyOTP() {
      if (!this.otpCode || this.otpCode.length !== 6) {
        this.otpInvalid = true;
        return;
      }
      this.isSubmitted = true;
      this.otpInvalid = false;
      const formData = new FormData();
      formData.append('user_id', this.userId);
      formData.append('code', this.otpCode);

      axios.post(this.apiUrl + '/verify-2fa', formData)
        .then(res => {
          this.isSubmitted = false;
          if (res.data.status) {
            vueCookies.set(this.cookieKey, {
              'user': res.data.data,
              'token': res.data.token
            });
            this.redirectUser(res.data);
          } else {
            this.otpInvalid = true;
          }
        })
        .catch(() => {
          this.isSubmitted = false;
          this.otpInvalid = true;
        });
    },

    // Optional: resend OTP
    resendOTP() {
      if (!this.userId) return;
      this.isSubmitted = true;
      axios.post(this.apiUrl + '/resend-otp', { user_id: this.userId })
        .then(() => { this.isSubmitted = false; })
        .catch(() => { this.isSubmitted = false; });
    },

    redirectUser(data) {
      setTimeout(() => {
        if (data.data.role_id === 1 || data.data.role_id === 0) {
          this.$router.push('/employee-management/dashboard');
        } else {
          this.$router.push('/employee/attendance');
        }
      }, 500);
    }
  }
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.container {
  width: 100%;
  max-width: 420px;
}

.header {
  text-align: center;
}

.logo {
  max-width: 340px;
}

.title {
  margin: 1rem 0;
  font-weight: bold;
  font-size: 40px;
}

.input-field {
  width: 100%;
  padding: 10px;
  margin-bottom: 16px;
  background: #2b2a33;
  color: white;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.submit-button {
  width: 100%;
  background: #4f46e5;
  color: white;
}

.error-text {
  color: #f87171;
  text-align: center;
}

.footer-text {
  text-align: center;
  margin-top: 1.5rem;
  font-size: 0.875rem;
  color: #6b7280;
}

.footer-link {
  color: #6366f1;
  font-weight: 600;
  text-decoration: none;
}

.footer-link:hover {
  color: #4f46e5;
}

.contact-info {
  position: fixed;
  bottom: 16px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  font-size: 0.75rem;
  z-index: 10;
}


.contact-address {
  display: inline-flex;
  align-self: flex-end;
  padding: 6px 10px;
  border-radius: 10px;
  line-height: 1.4;
  color: #484b50;
  background: rgba(79, 70, 229, 0.05);
  white-space: normal;
}

.contact-phone {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #46464d;
  transform: translateX(-90%);
}

.phone-icon svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  stroke: currentColor;
}

@media (max-width: 768px) {
  .contact-info {
    position: relative;
    bottom: auto;
    right: auto;
    margin-top: 2rem;
    width: 100%;
    align-items: center;
    text-align: center;
  }

  .contact-address {
    align-self: center;
    max-width: 90%;
  }

  .contact-phone {
    transform: none;
    justify-content: center;
  }
}
</style>
